const configRaw = require('webappConfig'); // eslint-disable-line

const env = { ...process.env }; // to get build time process env (not the runtime env) (hack)

// eslint-disable-next-line no-restricted-globals
const selfOrWindow =
  typeof window !== 'undefined'
    ? window
    : typeof self !== 'undefined'
      ? self
      : typeof global !== 'undefined'
        ? global
        : {};
export const HOSTNAME = selfOrWindow.location?.hostname;
export const PORT = selfOrWindow.location?.port;
export const PROTOCOL = selfOrWindow.location?.protocol || 'http:';

// DEV ONLY — eliminated from production bundles by Webpack's dead-code pass.
// Register this port with the redirect stub via a hidden iframe so the write
// lands in localhost:3000's localStorage (same-origin with the stub). Re-runs
// whenever the tab becomes visible, so switching browser tabs is all it takes
// to switch which dev server receives the next OAuth callback.
if (
  process.env.NODE_ENV !== 'production' &&
  PORT &&
  !(HOSTNAME === 'localhost' && PORT === '3000') &&
  typeof document !== 'undefined'
) {
  const registerDevDomain = () => {
    try {
      const devDomain = encodeURIComponent(`${PROTOCOL}//${HOSTNAME}${PORT ? `:${PORT}` : ''}`);
      const iframe = document.createElement('iframe');
      iframe.src = `http://localhost:3000/set-devdomain?domain=${devDomain}`;
      iframe.style.cssText = 'display:none';
      document.body.appendChild(iframe);
      setTimeout(() => iframe.remove(), 3000);
    } catch (_) {
      // ignore — stub may not be running
    }
  };

  registerDevDomain();
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      registerDevDomain();
    }
  });
}

export const ENVIRONMENT =
  (['localhost', 'machost'].includes(HOSTNAME)
    ? env.SERVICE_ENV
    : HOSTNAME && configRaw.hosts[HOSTNAME]?.environment_default) || 'stg';
export const BUILD_TYPE = (HOSTNAME && configRaw.hosts[HOSTNAME]?.build_override) || env.NODE_ENV || 'development';

function processConfig(config) {
  const newConfig = {};
  Object.keys(config).forEach((key) => {
    let keyObj;
    if (typeof config[key] === 'object' && !Array.isArray(config[key])) {
      keyObj = processConfig(config[key]);
    } else {
      keyObj = typeof config[key] === 'string' ? config[key].replace('ENV_PORT', PORT) : config[key];
    }
    newConfig[key] = keyObj;
  });

  return newConfig;
}

export const Config = processConfig(configRaw);

// we can't use logger here - some logger dependencies might not always available in backend environment
// eslint-disable-next-line no-console
// console.log(
//   '\nEnvironment:\n' +
//   '---------- build time\n' +
//   `NODE_ENV = ${env.NODE_ENV}\n` +
//   `SERVICE_ENV = ${env.SERVICE_ENV}\n` +
//   '---------- config (to use)\n' +
//   `BUILD_TYPE = ${BUILD_TYPE}\n` +
//   `ENVIRONMENT = ${ENVIRONMENT}\n` +
//   '---------- window\n' +
//   `HOSTNAME = ${HOSTNAME}\n` +
//   `PORT = ${PORT}\n` +
//   `PROTOCOL = ${PROTOCOL}\n` +
//   '---------- process.env\n',
//   process.env,
//   '\n---------- config\n',
//   Config,
// );
